/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import GradientButton from '../../MUICustomButton/GradientButton'
import CustomDataTable from '../../CustomDataTable/CustomDataTable'
import type { TableColumn } from 'react-data-table-component'
import type { ESPApiResponse, ESPStatusObj, RootState, ESP, ESPDeleteObj } from '../../types/types'
import { Link } from 'react-router-dom'
import { IconButton, Menu, MenuItem } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { UPDATE_CLIENT_ACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1, UPDATE_ESP_DEACTIVATE_SUBTITLE_2, UPDATE_USER_DELETE_SUBTITLE_1 } from 'src/constants/constant'
import OutlineButton from '../../MUICustomButton/OutlineButton'
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { activatedeactivateESP, getESPConnectionData, deleteESP } from 'src/services/emailAPIESPServices'
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import { useNavigate } from 'react-router-dom';
import {checkEventPermission} from "../../../common/utility/utility";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;



function ESPSettingsList(): JSX.Element {

  const [loading, setLoading] = useState<boolean>(false)
  const [espSettingsData, setESPSettingsData] = useState<ESP[]>([])
  const [espSearchData, setESPSearchData] = useState<ESP[]>([])
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const [selectedESPData, setSelectedESPData] = useState<ESP>();
  const [showDeactivateESPModal, setShowDeactivateclientModal] = useState<boolean>(false)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [showDeleteESPModal, setShowDeleteESPModal] = useState<boolean>(false)
  

  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate()

  useEffect(() => {
    getESPData()
  }, [])

  const getESPData = (): void => {
    setLoading(true)
    getESPConnectionData()
      .then(
        (res: ESPApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const espArr: any = [];
              res.data.data.map((data: any) => {
                  espArr.push(data)
                // }
              })
              setESPSettingsData(espArr)
              setESPSearchData(espArr)
            }

          }
        }
      )
      .catch(
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleActionClose = (event: React.MouseEvent<HTMLElement>, rowData: ESP, action: string | null = null): void => {
    setSelectedESPData(rowData)
    if (action === "delete") {
      setShowDeleteESPModal(true)
    } else if (action === "deactivate" || action === "activate") {
      setShowDeactivateclientModal(true)
    }
    setAnchorActionEl({ ...anchorActionEl, [rowData.id]: null });
  }

  const handleAddESPClick = (): void => {
    navigate('/email-api/esp-settings/add-espsettings')
  }

  const handleDeleteESPClose = (): void => {
    setShowDeleteESPModal(false)
  }

  const handleDeactivateESPClose = (): void => {
    setShowDeactivateclientModal(false)
  }

  const handleDeleteUserConfirm = (): void => {
      setIsModalSaveLoading(true)
      const data: ESPDeleteObj = {
        "deletedBy": user?.id,
        "espConnectionLst": [
          {
            "id": selectedESPData?.id
          }
        ]
      }
  
      deleteESP(data)
        .then(
          res => {
            if (res.status === 200) {
              
              NotificationManager.success("ESP deleted successfully")
              setIsModalSaveLoading(false)
              setShowDeleteESPModal(false)
              getESPData()
            }
          }
        )
        .catch (
          error => console.log("Error in delete ESP: ", error)
        )
    }

  const handleDeactivateESPConfirm = async (): Promise<void> => {
    setIsModalSaveLoading(true)
    const data: ESPStatusObj = {
      "modifiedBy": user?.id,
      "isActive": selectedESPData?.isActive === true ? false : true,
      "espConnectionLst": [
        {
          "id": selectedESPData?.id
        }
      ]
    }
    try {
      const res = await activatedeactivateESP(data);

      if (res.status === 200) {
        if (res.data.result === 1) {
          NotificationManager.success(
            ((selectedESPData?.isActive) === true)
              ? "ESP deactivated successfully"
              : "ESP activated successfully"
          );

          getESPData();
        }
      }
    } catch (error) {
      console.error("Error activating/deactivating ESP:", error);
      NotificationManager.error("An error occurred. Please try again.");
    } finally {
      setShowDeactivateclientModal(false);
      setIsModalSaveLoading(false);
    }
  }



  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let espDataArr = [...espSettingsData]
    if (value !== "") {
      // Ensure espDataArr exists and filter safely
      espDataArr = espDataArr?.filter((esp: ESP) => {
        const searchTerm = value.toLowerCase(); // Normalize input
        const nameMatch = esp.connectionName?.toLowerCase().includes(searchTerm) ?? false;
        const numberMatch = esp.connectionName?.match(/\d+/)?.some(num => num.includes(value)) ?? false;
    
        return nameMatch || numberMatch; // Match by either name or number
      });
    }

    setESPSearchData(espDataArr)
  }

  const columns: TableColumn<any>[] = [
    {
      name: 'Connection Name',
      selector: (row: any) => row.connectionName,
      width: '15%',
      sortable: true
    },
    {
      name: 'Domain',
      sortable: true,
      selector: (row: any) => row.domain,
      width: '15%',
      cell: (row: any) => <span>{row.domain}</span>
    },
    {
      name: 'From Email',
      sortable: true,
      width: '25%',
      selector: (row: any) => row.fromEmail,
      cell: (row: any) => <span>{row.fromEmail}</span>
    },
    {
      name: 'From Name',
      sortable: true,
      width: '20%',
      selector: (row: any) => row.fromName,
      cell: (row: any) => <span>{row.fromName}</span>
    },
    {
      name: 'Status',
      sortable: false,
      width: "10%",
      // selector: row => row.year,
      cell: (row: any) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      }
    },
    {
      name: 'Actions',
      sortable: false,
      id: 'action',
      width: "7%",
      style: {
        display: 'flex',
        justifyContent: 'flex-start'
      },
      // selector: row => row.year,
      cell: (row: any) => {
        return (
          <div className='flex items-center'>
            <div className="icon-hover-container">
              <Link to={{ pathname: `/email-api/esp-settings/edit/${row.id}` }} state={{ espData: row }} style={{ width: '20px' }} >
                <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="" />
              </Link>
            </div>
            <div className='flex'>
           { (checkEventPermission('ESP_ACTIVATE') || checkEventPermission('ESP_DELETE')) && (
            <>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                <HugeiconsIcon
                  icon={MoreVerticalSolidRounded}
                  size={24}
                  color="#77869E"
                  strokeWidth={0.5}
                />
              </IconButton>
              <Menu
                id={row.id.toString()}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '15ch',
                  },
                }}
              >
             {checkEventPermission('ESP_ACTIVATE') && 
                <MenuItem onClick={(e) => handleActionClose(e, row, row.isActive === true ? "deactivate" : "activate")}>
                  <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive === true ? "Deactivate" : "Activate"}</span>
                </MenuItem>
              }
              {checkEventPermission('ESP_DELETE') && 
                <MenuItem onClick={(e) => handleActionClose(e, row, "delete")}>
                  <span style={{ paddingLeft: '15px', color: '#F13139' }} className='text-muted font-normal'>Delete</span>
                </MenuItem>
              }
              </Menu>
              </>

      )}
            </div>

          </div>
        )
      }
    },
  ]

  return (
    <React.Fragment>
      <h2 className="text-2xl font-semibold text-title">ESP Settings</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by connection" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
        {checkEventPermission("ESP_ADD") &&
          <GradientButton color='red' onClick={handleAddESPClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add ESP Settings
          </GradientButton>
        }
        </div>
      </div>
      <div className='data-table-container mb-10'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={espSearchData.length > 0 ? espSearchData : []}
          pagination
          // selectableRows
          progressPending={loading}
        />
      </div>

      <BootstrapDialog
        onClose={handleDeactivateESPClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateESPModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {selectedESPData && selectedESPData.isActive === true ? "Deactivate ESP" : "Activate ESP"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDeactivateESPClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
           <HugeiconsIcon icon={MultiplicationSignStrokeStandard} size={24} color="currentcolor" strokeWidth={0.5}/> 
        </IconButton>
        <DialogContent>
          {
            selectedESPData !== undefined && selectedESPData.isActive === true ?
              <p className='text-14 text-muted'>{UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedESPData !== undefined ? selectedESPData.connectionName : ''} `}</span> {UPDATE_ESP_DEACTIVATE_SUBTITLE_2}</p>
              :
              <p className='text-14 text-muted'>{UPDATE_CLIENT_ACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedESPData !== undefined ? selectedESPData.connectionName : ''}`}</span> {UPDATE_ESP_DEACTIVATE_SUBTITLE_2}</p>
          }

        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color='gray' onClick={handleDeactivateESPClose} width='130px'>Cancel</OutlineButton>
          <GradientButton color='red' onClick={() => {
            void handleDeactivateESPConfirm();
          }} width='130px'>{
              isModalSaveLoading ? (
                <span className="loading loading-spinner loading-xs text-white"></span>
              ) : ((selectedESPData?.isActive) === true) ? "Deactivate" : "Activate"
            }</GradientButton>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
          onClose={handleDeleteESPClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteESPModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete ESP
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleDeleteESPClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{`${selectedESPData !== undefined ? selectedESPData.connectionName : ''}`}</span> {UPDATE_ESP_DEACTIVATE_SUBTITLE_2}</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleDeleteESPClose} width='130px'>Cancel</OutlineButton>
            <GradientButton color='red' onClick={handleDeleteUserConfirm} width='130px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

    </React.Fragment>
  )
}

export default ESPSettingsList